/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import ErrorBoundary from "..";
import { useNotificationContext } from "../../../contexts/notificationContext";

const ErrorBoundaryWrapper = ({ children }) => {
  const showNotification = useNotificationContext();

  return (
    <ErrorBoundary showNotification={showNotification}>
      {children}
    </ErrorBoundary>
  );
};

export default ErrorBoundaryWrapper;
